import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-category',
  templateUrl: './card-category.component.html',
  styleUrls: ['./card-category.component.scss']
})
export class CardCategoryComponent implements OnInit {

  @Input() image:     string = '';
  @Input() name:      string = '';
  @Input() skeleton:  boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
